<form [formGroup]="medicineDosagePackageTypeForm" class="row">
    <p class="col-md-6">
        <mat-form-field appearance="outline">
            <mat-label>Label name</mat-label>
            <input required formControlName="labelName" placeholder="Label name" type="text" matInput>
            <mat-error *ngIf="medicineDosagePackageTypeForm.get('labelName')?.invalid">
                Label name is invalid {{labelNameExceeds25Chars ? ": Max 25 characters allowed" : ""}}
            </mat-error>
            <mat-hint>Maximum of 25 characters</mat-hint>
        </mat-form-field>
    </p>

    <p class="col-md-6">
        <mat-form-field appearance="outline">
            <mat-label>Price</mat-label>
            <input required formControlName="price" placeholder="Price" type="number" matInput>
            <mat-error *ngIf="medicineDosagePackageTypeForm.get('price')?.invalid">
                Price is invalid
            </mat-error>
        </mat-form-field>
    </p>
    <p class="col-md-6"> 
        <mat-form-field appearance="outline">
            <mat-label>Package Type</mat-label>
            <mat-select required formControlName="packageType">
                <mat-option *ngFor="let type of data.packageTypes" [value]="type">
                    {{type.type}}
                </mat-option>
            </mat-select>
            <button type="button" matSuffix mat-icon-button (click)="createPackageType($event)">
                <mat-icon>add</mat-icon>
            </button>
            <mat-error *ngIf="medicineDosagePackageTypeForm.get('packageType')?.invalid">
                Package type is invalid
            </mat-error>
        </mat-form-field>
    </p>

    <p class="col-md-6"> 
        <mat-form-field appearance="outline">
            <mat-label>Quantity</mat-label>
            <input required formControlName="containedQuantity" placeholder="Quantity" type="number" step="0.01" matInput>
            <mat-error *ngIf="medicineDosagePackageTypeForm.get('containedQuantity')?.invalid">
                Quantity is invalid
            </mat-error>
        </mat-form-field>
    </p>
</form>
<div mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
    <button [disabled]="!medicineDosagePackageTypeForm.valid" mat-raised-button  color="primary" (click)="save()">
       Save
    </button>
</div>
